/**
 * Retrieves the matched field ID based on the input reference, unit, and selection state.
 *
 * @param inputRef - The reference to the input element.
 * @param unit - A string representing the unit type (e.g., "batser").
 * @param select - A boolean indicating whether the input is a select element.
 * @returns The matched field ID as a string, or null if no match is found.
 */
export const getMatchedFieldId = (
  inputRef: HTMLInputElement,
  unit: string,
  select: boolean,
) => {
  const otherRow = unit.includes("batser") ? 1 : 0;

  let cell: HTMLElement | null | undefined;

  if (select) {
    cell =
      inputRef?.parentElement?.parentElement?.parentElement?.parentElement
        ?.parentElement;
  } else {
    cell = inputRef?.parentElement?.parentElement?.parentElement;
  }

  if (!cell) return null;

  const row = cell?.parentElement;
  if (!row) return null;

  const cellIndex = Array.prototype.indexOf.call(row.children, cell);
  if (cellIndex === -1) return null;

  const otherCell = row.parentElement?.children[otherRow].children[cellIndex];
  if (!otherCell) return null;

  if (select) {
    return (otherCell.querySelector("input[type='hidden']") as HTMLInputElement)
      ?.name;
  }

  return (otherCell.querySelector("input") as HTMLInputElement)?.name;
};
/**
 * Retrieves the matched value from local storage based on the provided value and unit.
 *
 * @param value - The value to match against the stored data.
 * @param unit - An optional string representing the unit type.
 * @returns The matched value as a string, or null if no match is found.
 */
export const getMatchedValue = (value: string, unit?: string) => {
  const yachtdata = JSON.parse(localStorage.getItem("yachtData") ?? "{}");
  let key = unit;
  if (!unit && yachtdata.gmdss) {
    key = Object.keys(yachtdata.gmdss).find(
      k => k.includes("bat") && yachtdata.gmdss[k] === value,
    );
  }

  if (!key) return null;

  const matchedKey = key.includes("ser")
    ? key.replace("ser", "exp")
    : key.replace("exp", "ser");

  return yachtdata?.gmdss?.[matchedKey] ? yachtdata.gmdss[matchedKey] : "";
};
